<div class="email-input">
  @for (contact of contacts; track contact) {
    <div class="email-chips">
      <span class="email-chip">
        <span class="chip-status">
          <od-svg-icon class="svg-wrapper" name="icon-circle" [parentSize]="true"></od-svg-icon>
        </span>
        <span class="chip-name">{{ contact.displayName ? contact.displayName : contact.mail }}</span>
        <span (click)="removeContact(contact)" class="chip-close">
          <od-svg-icon class="svg-wrapper" name="icon-times" [parentSize]="true"></od-svg-icon>
        </span>
      </span>
    </div>
  }
  <input #input [formControl]="collaborationInput" (focus)="showContactsPanel()" (blur)="hideContactsPanel()"
    (keydown.enter)="checkEmail($event)" (keydown.,)="checkEmail($event)" (keydown.tab)="checkEmail($event)"
    (input)="makeSearch($event.target.value)" type="text" class="input">
</div>

@if (showContacts && showGraphApiContacts) {
  <div class="email-container">
    <div class="contacts-wrapper">
      @if (contacts) {
        @for (contactCategory of searchContacts; track contactCategory) {
          @for (contact of contactCategory; track contact) {
            <div>
              <div (mousedown)="addContact(contact)" class="contact-body">
                <img [src]="contact.photo" alt="contact" class="contact-image">
                <div class="contact-info">
                  <div class="contact-name">{{ contact.displayName }}</div>
                  <div class="contact-subtitle">{{ contact.customSubtitle || CONTACT_TYPES_NAMES[contact.type] }}
                  </div>
                </div>
              </div>
            </div>
          }
          @if (contactCategory.length > 1) {
            <div class="divider"></div>
          }
        }
      }
      @if (listStatus === GraphResponseStatus.COMPLETE) {
        @if (isContactsEmpty) {
          <span class="contact-body">No contacts found, please search again.</span>
        }
      } @else {
        <span>{{ MESSAGE_GRAPH_API_STATUS[listStatus] }}</span>
      }
    </div>
  </div>
}
